import { useMemo } from 'react'
import deepEqual from 'fast-deep-equal'

type FilterValues = Record<string, unknown>

const countActiveFilters = <T extends FilterValues>(
    activeFilters: T,
    defaultFilters: T
): number => {
    let count = 0

    const filterKeys = Object.keys(activeFilters) as Array<keyof T>

    for (const key of filterKeys) {
        const activeValue = activeFilters[key]
        const defaultValue = defaultFilters[key]

        if (activeValue == null) continue

        if (!deepEqual(activeValue, defaultValue)) {
            count++
        }
    }

    return count
}

export const useActiveFiltersCount = <T extends FilterValues>(
    activeFilters: T,
    defaultFilters: T
): number => {
    return useMemo(
        () => countActiveFilters(activeFilters, defaultFilters),
        [activeFilters, defaultFilters]
    )
}
